import axios from "axios";

// Adresse de l'API (backend Symfony).
// En production, remplacez l'adresse ci-dessous par celle de votre backend
// (ou définissez VUE_APP_API_URL dans un fichier .env.production).
const API_PRODUCTION = "https://admin.groupeviras.com/api/v1";
const API_DEVELOPPEMENT = "http://localhost:8000/api/v1";

const api = axios.create({
  baseURL:
    process.env.VUE_APP_API_URL ||
    (process.env.NODE_ENV === "production" ? API_PRODUCTION : API_DEVELOPPEMENT),
  timeout: 12000,
  headers: { Accept: "application/json" },
});

export default api;
